// extracted by mini-css-extract-plugin
export default {"ProjectGallery":"ProjectGallery_ProjectGallery__KcELN"};